import {CSS3DObject} from "three/examples/jsm/renderers/CSS3DRenderer.js";

const createTips = (domId) => {
    const elem = document.querySelector(domId);
    const htmlMesh = new CSS3DObject(elem);
    htmlMesh.scale.set(0.2, 0.2, 0.2);
    htmlMesh.visible = false;
    return htmlMesh;
}

export {createTips}
